import { createContext } from 'react';
import { OutboundCallEntity } from '@lib/types/common-call-types';

export type ITransferringCallItem = {
  name: string;
  number: string;
};

type TransferringCallContextType = {
  from: ITransferringCallItem;
  to: ITransferringCallItem;
  transferType: OutboundCallEntity;
  handleTransfer: (number: string) => void;
  handleWarmTransfer: (number: string) => void;
  onClose: () => void;
};

export const TransferringCallContext = createContext<
  TransferringCallContextType | undefined
>(undefined);
